module.exports = __webpack_public_path__ + "img/SpreadYourWingsAndFly.7f835edd.jpg";